const ArrowLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M15.0004 7.49967H3.83041L8.71041 2.61967C9.10041 2.22967 9.10041 1.58967 8.71041 1.19967C8.6179 1.10697 8.50801 1.03342 8.38704 0.983238C8.26606 0.933056 8.13638 0.907227 8.00541 0.907227C7.87444 0.907227 7.74476 0.933056 7.62379 0.983238C7.50282 1.03342 7.39293 1.10697 7.30041 1.19967L0.710413 7.78967C0.617709 7.88218 0.544162 7.99207 0.49398 8.11305C0.443799 8.23402 0.417969 8.3637 0.417969 8.49467C0.417969 8.62564 0.443799 8.75532 0.49398 8.87629C0.544162 8.99727 0.617709 9.10716 0.710413 9.19967L7.30041 15.7897C7.39299 15.8823 7.50291 15.9557 7.62387 16.0058C7.74483 16.0559 7.87448 16.0817 8.00541 16.0817C8.13634 16.0817 8.26599 16.0559 8.38696 16.0058C8.50792 15.9557 8.61783 15.8823 8.71041 15.7897C8.80299 15.6971 8.87643 15.5872 8.92654 15.4662C8.97664 15.3452 9.00243 15.2156 9.00243 15.0847C9.00243 14.9537 8.97664 14.8241 8.92654 14.7031C8.87643 14.5822 8.80299 14.4723 8.71041 14.3797L3.83041 9.49967H15.0004C15.5504 9.49967 16.0004 9.04967 16.0004 8.49967C16.0004 7.94967 15.5504 7.49967 15.0004 7.49967Z"
        fill="black"
      />
    </svg>
  );
};
export default ArrowLeft;
